<article class="fadein animation-duration-100 relative overflow-hidden">
  <section *ngIf="mapId" [id]="mapId" class="z-3"></section>

  <section
    class="w-fit absolute bottom-0 right-0 mb-2 mr-2 md:mb-3 md:mr-3 z-4 flex flex-column gap-3 fadeinright animation-duration-500">
    <section (click)="openSafeTaxiChecker()"
      class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg-glass-5 shadow-2 ci-bg-glass--yellow border-circle flex flex-column align-items-center justify-content-center">
      <img src="assets/images/pins/safeTaxiIcon.svg" alt="Safe taxi icon" class="w-11 mx-auto">
    </section>

    <section (click)="showHideResults()"
      class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg-glass-5 shadow-2 border-circle flex align-items-center justify-content-center relative">
      <i class="bi bi-truck-front text-2xl md:text-3xl ci-txt--black-lighten cursor-pointer"></i>

      <section *ngIf="selectedLine"
        class="p-1 absolute top-0 right-0 -mt-1 ci-bg--cherry border-circle flex align-items-center justify-content-center">

        <i class="bi bi-sign-turn-slight-right ci-txt--white" style="font-size: 12px;"></i>
      </section>
    </section>

    <section
      class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg-glass-5 shadow-2 border-circle flex align-items-center justify-content-center relative"
      (click)="isVisible = !isVisible">
      <i class="bi bi-layers text-2xl md:text-3xl ci-txt--black-lighten cursor-pointer"></i>

      <section *ngIf="checkedItemsLength > 0" class="absolute top-0 right-0 -mt-1 -mr-1">
        <p-badge [value]="checkedItemsLength" />
      </section>
    </section>

    <section *ngIf="_currentLocationMarker"
      class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg-glass-5 shadow-2 border-circle flex align-items-center justify-content-center"
      (click)="goToCurrentLocation()">
      <i class="bi bi-crosshair text-2xl md:text-3xl ci-txt--black-lighten cursor-pointer"></i>
    </section>
  </section>

  <section *ngIf="selectedLine?.line" class="w-full absolute top-0 p-3 flex justify-content-center align-items-center">
    <div
      class="w-fit border-round-2xl py-3 px-4 flex align-items-center shadow-5 bg-white-alpha-80 shadow-4 z-5 fadein animation-duration-500 relative">
      <section class="w-full">
        <section class="flex gap-2 align-items-center text-xl md:text-2xl">
          <div class="flex align-items-center font-semibold ci-txt--black">
            Línea - <span class="ml-2">{{selectedLine?.line}}</span>
          </div>
        </section>

        <section class="w-full pt-2">
          <section class="w-full flex justify-content-between align-items-center gap-4">
            <small class="ci-txt--black-lighten">Partida</small>
            <i class="bi bi-slash-lg text-3xl ci-txt--green-traffic rotate-45"></i>
          </section>

          <section class="w-full flex justify-content-between align-items-center -mt-2 gap-4">
            <small class="ci-txt--black-lighten">Retorno</small>
            <i class="bi bi-slash-lg text-3xl ci-txt--red-traffic rotate-45"></i>
          </section>
        </section>
      </section>

      <section
        class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center absolute top-0 right-0 -mr-1">
        <i class="bi bi-x-circle-fill text-2xl ci-txt--cherry cursor-pointer" (click)="removeSelectedLine()"></i>
      </section>
    </div>
  </section>
</article>

<ng-template #labelTemplate>
  <h4 class="w-full text-center text-lg mb-1 font-semibold ci-txt--black-lighten">
    Información
  </h4>

  <section class="w-full sticky top-0">
    <p-tabMenu [model]="items" [activeItem]="items[0]" (activeItemChange)="onTabChange($event)" />
  </section>

  <section *ngFor="let item of filteredCheckboxItems; let i = index">
    <label class="flex align-items-center justify-content-between cursor-pointer py-3 fadein animation-duration-500"
      [ngClass]="{'border-gray-300 border-bottom-1': i < filteredCheckboxItems.length-1}">
      <section class="flex align-items-center gap-1 mr-3">
        <section class="w-2rem h-2rem">
          <img class="h-full w-auto" alt="Item Icon" [src]="item?.icon">
        </section>

        <span class="ci-txt--black text-lg">
          {{ item.label }}
        </span>
      </section>

      <input *ngIf="!item.disabled" class="ml-3" type="checkbox" [checked]="item.isChecked" [disabled]="item?.disabled"
        (change)="execCheckboxFunctions(i)">
    </label>
  </section>
</ng-template>

<p-dialog [(visible)]="isVisible" [closable]="false" [modal]="true" [dismissableMask]="true" [header]="'.'" [position]="'bottom'">
  <section class="w-screen sm:w-25rem flex flex-column px-3">
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  </section>

  <section class="w-fit fixed top-0 right-0 mr-1 md:mr-0">
    <section class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center"
      (click)="closeDialog()">
      <i class="bi bi-x-circle-fill text-3xl ci-txt--cherry cursor-pointer"></i>
    </section>
  </section>

  <ng-template pTemplate="footer">
    <section class="w-full p-3">
      <button class="w-full ci-btn ci-btn--small ci-btn__purple" (click)="closeDialog()">
        Aplicar capas
      </button>
    </section>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showResults" [closable]="false" [modal]="true" [dismissableMask]="true" [header]="'.'" [position]="'bottom'">
  <section class="w-screen sm:w-28rem md:w-30rem flex flex-column gap-3 p-3 pt-0">
    <section class="w-full">
      <section class="flex align-items-center justify-content-between">
        <h4 class="ci-txt--black-lighten flex align-items-center text-xl md:text-2xl font-semibold">
          <i class="bi bi-sign-turn-slight-right-fill mr-2 ci-txt--yellow"></i>
          Líneas de transporte
        </h4>

        <section class="w-fit fixed top-0 right-0">
          <section class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center"
            (click)="showHideResults()">
            <i class="bi bi-x-circle-fill text-2xl ci-txt--cherry cursor-pointer"></i>
          </section>
        </section>
      </section>

      <section class="w-full ci-txt--black-lighten pb-3 pt-2">
        <small *ngIf="!selectedLine?.line" class="md:text-lg fadein animation-duration-500">
          Selecciona una línea
        </small>
      </section>

      <section class="w-screen sm:w-full flex align-items-center">
        <section *ngIf="selectedLine?.line" class="sticky left-0 border-right-2 pr-2 mr-2 border-gray-300">
          <section
            class="ci-line-marked w-4rem h-4rem md:w-5rem md:h-5rem fadein animation-duration-500 ci-bg--yellow border-round-xl flex flex-column justify-content-center align-items-center relative">
            <p class="ci-txt--white">
              Línea
            </p>

            <h4 class="text-2xl ci-txt--white">
              {{selectedLine.line}}
            </h4>

            <section (click)="removeSelectedLine()"
              class="w-2rem h-2rem shadow-3 cursor-pointer ci-bg--white absolute -mt-3 -mr-3 top-0 right-0 border-round-3xl flex align-items-center justify-content-center ci-bg--cherry">
              <i class="bi bi-trash text-md ci-txt--white"></i>
            </section>
          </section>
        </section>

        <section *ngIf="filteredLines.length > 0" class="overflow-auto">
          <swiper-container slides-per-view="auto" free-mode="true">
            <swiper-slide *ngFor="let item of filteredLines, index as i" class="w-fit cursor-pointer mr-3"
              [ngClass]="{'hidden': item.line === selectedLine?.line}">
              <section
                class="w-4rem h-4rem md:w-5rem md:h-5rem fadein animation-duration-500 ci-bg--purple-lighten border-round-xl flex flex-column justify-content-center align-items-center"
                id="line-{{i}}" (click)="markLineRoute(item, i)"
                [ngClass]="{'ci-line-marked': item.line === selectedLine?.line}">
                <p class="ci-txt--white">
                  Línea
                </p>

                <h4 class="text-2xl ci-txt--white">
                  {{item.line}}
                </h4>
              </section>
            </swiper-slide>
          </swiper-container>
        </section>
      </section>

      <section *ngIf="(filteredLines.length === 0) && (!selectedLine)"
        class="h-4rem md:h-5rem px-3 bg-black-alpha-10 fadein animation-duration-500 flex flex-column justify-content-center align-items-center border-round-2xl">
        <p class="text-lg md:text-xl ci-txt--black-lighten flex align-items-center">
          <i class="bi bi-exclamation-diamond text-3xl md:text-4xl ci-txt--red mr-2"></i>

          No hay coincidencias con la búsqueda...
        </p>
      </section>

      <!-- <section *ngIf="selectedLine?.line" class="w-full fadein animation-duration-500 flex align-items-center justify-content-end ci-bg--white mt-3">
        <section class="flex align-items-center gap-1 cursor-pointer ci-txt--black-lighten" (click)="removeSelectedLine()">
          <i class="bi bi-eraser"></i> <small>Limpiar todo</small>
        </section>
      </section> -->
    </section>

    <section class="flex align-items-center border-round-xl px-2 border-1 shadow-1 border-gray-300 ci-bg--white">
      <section>
        <i class="bi bi-search text-lg ci-txt--black-lighten"></i>
      </section>

      <input type="text" placeholder="Busca una línea de transporte..." (focus)="onFocus()" (input)="onInputChange()"
        [(ngModel)]="searchQuery">

      <section *ngIf="searchQuery !== ''" (click)="clearInput()">
        <i class="bi bi-x-circle-fill text-lg ci-txt--grey cursor-pointer"></i>
      </section>
    </section>
  </section>
</p-dialog>

<p-dialog [(visible)]="showTaxiChecker" [closable]="false" [modal]="true" [dismissableMask]="true" [header]="'.'" [position]="'bottom'">
  <section class="relative">
    <app-safe-taxi-checker (closeEvent)="closeSafeTaxiChecker()"></app-safe-taxi-checker>

    <section class="w-fit fixed top-0 right-0 mr-1 md:mr-0">
      <section class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center"
        (click)="closeSafeTaxiChecker()">
        <i class="bi bi-x-circle-fill text-3xl ci-txt--cherry cursor-pointer"></i>
      </section>
    </section>
  </section>
</p-dialog>
